import { useCallback, useState } from 'react';

const readStoredBoolean = (key, fallback) => {
  try {
    const stored = window.localStorage.getItem(key);
    return stored === null ? fallback : stored === 'true';
  } catch {
    return fallback;
  }
};

export const usePersistentBoolean = (key, fallback = false) => {
  const [value, setValue] = useState(() => readStoredBoolean(key, fallback));

  const setPersistentValue = useCallback((nextValue) => {
    setValue((currentValue) => {
      const resolvedValue = typeof nextValue === 'function' ? nextValue(currentValue) : nextValue;
      try {
        window.localStorage.setItem(key, String(Boolean(resolvedValue)));
      } catch {
        // The UI still works when browser storage is unavailable.
      }
      return Boolean(resolvedValue);
    });
  }, [key]);

  return [value, setPersistentValue];
};
